import { ClipboardList } from 'lucide-react';

type Props = {
  subtitle?: string;
};

export const PageTitle = ({ subtitle = 'Controle' }: Props) => {
  return (
    <div className="flex items-center gap-2 font-GilroySemibold">
      <ClipboardList className="h-5 w-5" />
      <h1 className="text-md">
        <span className="font-GilroySemibold">Viagens</span>
        <span className="font-GilroyRegular uppercase ml-2">{subtitle}</span>
      </h1>
    </div>
  );
};
